import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import Bill from "../../Models/Bill";
import {BillingParams, BillingReducerType} from "./Types";
import {Customer} from "../../Models/Customer";
import moment from "moment";

const initialState : BillingReducerType = {
  bills: [],
  billOptionList:[]
}

const BillingSlice = createSlice({
  name: "Billing",
  initialState,
  reducers: {
    getBills(state: BillingReducerType, {payload}: PayloadAction<BillingParams>){},
    setBills(state: BillingReducerType, {payload}: PayloadAction<Bill[]>) {
      state.bills = payload;
      state.billOptionList = payload?.map((bill)=>{
        return({
          id: bill?._KEY,
          consecutive: bill?.consecutive,
          code: (bill.customer as Customer)?.code,
          name: (bill?.customer as Customer)?.name,
          payment_date: moment(bill?.payment_date).format('DD-MM-YYYY') });
      })

    }
  }
});


export const BillingActions = BillingSlice.actions;
export default BillingSlice.reducer;
